export const styleFontColor = {
  bgBlueGrey: '#F7F9FC',
  txDarkGray: '#1A1A1A',
  txLightGrey: '#777A7C',
};
